
const getters = {
  // 设备数据
  header: state => state.device,
  // 用户登录令牌
  token: state => state.device.token,
  // 选择的企业前缀
  selectOrgId: state => state.user.selectOrgId
}
export default getters



// WEBPACK FOOTER //
// ./src/store/getters.js